import PlinkoGraphicBase from './Base'

interface RippleConstructor {
  x: number
  y: number
  size: number
  origin: number
  id: number
}

class Ripple extends PlinkoGraphicBase {
  x: number
  y: number
  size: number
  origin: number
  id: number

  constructor(Matter: any, paramater: RippleConstructor) {
    const { x, y, size, origin, id } = paramater
    const options = {
      restitution: 1,
      friction: 0,
      isStatic: true,
    }

    const body = Matter.Bodies.circle(x, y, size, options)
    super(Matter, body)

    this.x = x
    this.y = y
    this.size = size
    this.origin = origin

    this.body = body
    this.id = id
  }

  display(p5: any) {
    const pos = this.body.position
    const angle = this.body.angle

    p5.push()
    p5.translate(pos.x, pos.y)
    p5.rotate(angle)
    p5.imageMode(p5.CENTER)
    p5.noStroke()
    p5.fill(
      255 - (this.size - this.origin) * 13,
      255 - (this.size - this.origin) * 13,
      255 - (this.size - this.origin) * 13,
    )
    p5.ellipseMode(p5.RADIUS)
    p5.ellipse(0, 0, this.size, this.size)
    p5.pop()

    this.size += 0.4
  }
}

export default Ripple
